import { render, staticRenderFns } from "./WarehousingAdd.vue?vue&type=template&id=0bca2e2e&scoped=true"
import script from "./WarehousingAdd.vue?vue&type=script&lang=js"
export * from "./WarehousingAdd.vue?vue&type=script&lang=js"
import style0 from "./WarehousingAdd.vue?vue&type=style&index=0&id=0bca2e2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca2e2e",
  null
  
)

export default component.exports